module.exports = {
  colors: {
    // BASE (primary blue)
    'base-darkest': '#07182C',
    'base-darker': '#0E2A4E',
    'base-dark': '#14356B',
    'primary-base': '#1C3C7C',
    // semantic ticket-card text tokens (shared PriceCard) — kihnu design
    'card-title': '#1C3C7C',
    // hex for the kihnu-specific components while `card-*` serves the shared ticket cards.
    'card-desc': '#677794',
    'card-label': '#67748C',
    'card-value': '#34435E',
    'card-quantity': '#34435E',
    'card-subtotal': '#34435E', // = card-value
    interactive: '#2176B6',
    'base-medium-light': '#2176B6',
    'base-normal-light': '#79A9D4',
    'base-normal-lighter': '#A9C8E5',
    'base-very-light': '#D4E4F2',
    'base-lightest': '#EAF3FA',
    'base-muted': '#7E97AE',
    'base-muted-light': '#9FB2D4',

    // SECONDARY (teal)
    'secondary-darkest': '#0A2E28',
    'secondary-darker': '#114F45',
    'secondary-dark': '#1A7B6B',
    secondary: '#2FB3A0',
    'secondary-medium-light': '#4FC2AF',
    'secondary-medium-lighter': '#74CEBF',
    'secondary-normal-light': '#99DACE',
    'secondary-normal-lighter': '#BFE6DE',
    'secondary-very-light': '#E4F5F1',
    'secondary-lightest': '#F0FAF7',

    // TERTIARY (warm sand)
    'tertiary-darkest': '#272520',
    'tertiary-darker': '#474239',
    'tertiary-dark': '#665F52',
    tertiary: '#857C6B',
    'tertiary-medium-light': '#A59A85',
    'tertiary-medium-lighter': '#C4B79E',
    'tertiary-normal-light': '#D4CAB8',
    'tertiary-normal-lighter': '#E3DDD2',
    'tertiary-very-light': '#F3F1EC',

    // COMPLIMENTARY (indigo)
    'complimentary-darkest': '#12182B',
    'complimentary-darker': '#2A3864',
    'complimentary-dark': '#42589D',
    complimentary: '#5A78D6',
    'complimentary-medium-light': '#748EDD',
    'complimentary-medium-lighter': '#8FA3E3',
    'complimentary-normal-light': '#A9B9EA',
    'complimentary-normal-lighter': '#C4CEF0',
    'complimentary-very-light': '#DEE4FA',
    'complimentary-lightest': '#EFF2FD',

    // NEUTRAL
    'neutral-darkest': '#1C1C1C',
    'neutral-darker': '#393939',
    'neutral-dark': '#555555',
    neutral: '#727272',
    'neutral-medium-light': '#8E8E8E',
    'neutral-medium-lighter': '#A5A5A5',
    'neutral-normal-light': '#BBBBBB',
    'neutral-normal-lighter': '#D2D2D2',
    'neutral-very-light': '#E8E8E8',
    'neutral-lightest': '#F4F4F4',
    'neutral-ultra-lightest': '#FAFAFA',
    'neutral-background-profile': '#FAFAFA',

    // SUCCESS
    'success-darkest': '#0E260E',
    'success-darker': '#14401F',
    // success/500 — "green means applied": the new-departure chip, its icon, and the resident-ID
    // line in the cart. Distinct from `success` below, which is the availability gauge.
    'success-dark': '#2E6B33',
    success: '#2CA05A',
    'success-medium-light': '#44BF44',
    'success-medium-lighter': '#69CC69',
    'success-normal-light': '#8FD98F',
    'success-normal-lighter': '#B4E5B4',
    'success-very-light': '#E4F4E4',

    // WARNING
    'warning-darkest': '#332B05',
    'warning-darker': '#665709',
    'warning-dark': '#7A6212',
    warning: '#9A7B1F',
    'warning-medium-light': '#E0A812',
    'warning-medium-lighter': '#C9B96A',
    'warning-normal-light': '#ECDD9A',
    'warning-normal-lighter': '#FDF3C4',
    'warning-very-light': '#FBF3D0',
    // not in design palette
    'warning-lightest': '#FFF7E8',

    // ERROR
    'error-darkest': '#2D0A06',
    'error-darker': '#5A140C',
    'error-dark': '#861D11',
    error: '#C0392B',
    'error-medium-light': '#D6402C',
    'error-medium-lighter': '#E65A4A',
    'error-normal-light': '#EC8377',
    'error-normal-lighter': '#F3ADA5',
    'error-very-light': '#F9D6D2',
    'error-lightest': '#FCEBE9',

    // INFO
    'info-darkest': '#082431',
    'info-darker': '#104861',
    info: '#2091C2',
    'info-medium-light': '#28B5F3',
    'info-medium-lighter': '#53C4F5',
    'info-normal-light': '#7ED3F8',
    'info-normal-lighter': '#A9E1FA',
    'info-very-light': '#D4F0FD',

    'frozen-ice': '#28B5F3',
    'gauge-none': '#CBD2DC',
    'gauge-track': '#E3E7EE',
    'gauge-text-disabled': '#AAB2C0',

    'surface-sunken': '#ECEEF1',

    'text-body': '#34435E',
    'text-muted': '#5A6B86',
    'text-blue': '#2152A8',
    'text-faint': '#677794',
    'text-label': '#647799',

    'border-success': '#4E9C59',
    'border-line': '#CDD8E8',
    'border-line-strong': '#B9CFE6',
    'border-soft': '#CDDDEE',
    'border-dotted': '#C7D4E6',

    'base-medium-light-hover': '#1B6299',
    'base-disabled': '#A8BFD4',
    'surface-tile': '#F5FAFF',
    'surface-tile-hover': '#EAF3FC',
    'surface-danger': '#FDF3F2',
    'border-danger': '#F0C9C4',
    'border-danger-hover': '#E3A79F',
  },

  extend: {
    fontSize: {
      'ticket-title': ['20px', { lineHeight: '1.3', letterSpacing: '-0.01em', fontWeight: '700' }],
      'ticket-caption': ['14px', '1.4'],
      'ticket-amount': ['19px', { lineHeight: '1.3', fontWeight: '400' }],
      'ticket-subtotal': ['19px', { lineHeight: '1.3', fontWeight: '400' }], // = ticket-amount
      'ticket-qty': ['17px', { lineHeight: '1.2', fontWeight: '400' }],
    },

    fontFamily: {
      sans: [
        'var(--font-hanken-grotesk)',
        '"Hanken Grotesk"',
        'system-ui',
        '-apple-system',
        '"Segoe UI"',
        'sans-serif',
      ],
    },

    boxShadow: {
      xs: '0 1px 4px rgba(28,60,124,.05)',
      sm: '0 2px 6px rgba(28,60,124,.08)',
      card: '0 2px 8px rgba(28,60,124,.10)',
      panel: '0 2px 10px rgba(28,60,124,.10)',
      hover: '0 5px 14px rgba(28,60,124,.22)',
      // Priced-dropdown panel
      dropdown: '0 12px 28px rgba(28,60,124,.16)',
      'pill-active': '0 2px 8px rgba(33,118,182,.28)',
      cta: '0 4px 14px rgba(47,179,160,.35)',
      'cta-hover': '0 8px 20px rgba(47,179,160,.40)',
      // blue CTA of the vehicle/trailer cards
      'cta-blue': '0 3px 10px rgba(33,118,182,.22)',
      'cta-blue-hover': '0 6px 16px rgba(28,60,124,.24)',
      'danger-hover': '0 8px 20px rgba(192,57,43,.34)',
      success: '0 3px 10px rgba(78,156,89,.2)',
      'success-hover': '0 4px 12px rgba(78,156,89,.18)',
      // Schedule departure rows
      'row-selected': '0 4px 12px rgba(33,118,182,.30)',
      'row-flat': '0 1px 4px rgba(28,60,124,.06)',
      'row-hover': '0 0 0 2px #C9D6F5, 0 6px 14px rgba(201,214,245,.22)',
    },

    backgroundImage: {
      // The page background
      'kihnu-sky': 'linear-gradient(180deg, #CFE6F5 0px, #E1EFF9 360px, #E6F1FB 100%)',
      'kihnu-ribbon': "url('/kihnu/images/ribbon.png')",
    },
  },
}
